import type { CalculatedInternalResponse } from 'api/__GENERATED';
import * as R from 'remeda';

// Maps a single CalculatedInternal DTO onto the `Data.CalculatedInternal` shape.
// `subZoneId` is required by the domain — rows without it can't be addressed and are dropped.
// `movingTotal` starts null; `toCalculatedInternalDomain` decorates it via `decorateDomainWithMovingValue`.
function toCalculatedInternal(
  dto: CalculatedInternalResponse,
): Data.CalculatedInternal | undefined {
  const {
    id,
    zoneId,
    subZoneId,
    employeeId,
    year,
    monthNumber,
    weekNumber,
    dayOfMonth,
    dayOfWeek,
    receivedItemCount,
    processedItemCount,
    backlogItemCount,
  } = dto;

  if (
    !R.isDefined(year) ||
    !R.isDefined(monthNumber) ||
    !R.isDefined(weekNumber) ||
    !R.isDefined(dayOfMonth) ||
    !R.isDefined(dayOfWeek) ||
    !R.isDefined(subZoneId)
  ) {
    return undefined;
  }

  const calculatedInternal: Data.CalculatedInternal = {
    id,
    year,
    month: monthNumber - 1,
    week: weekNumber,
    dayOfMonth,
    dayOfWeek,
    zoneId,
    subZoneId,
    employeeId: employeeId ?? null,
    noReceived: receivedItemCount ?? null,
    noProcessed: processedItemCount ?? null,
    noBacklog: backlogItemCount ?? null,
    movingTotal: null,
  };

  return calculatedInternal;
}

export { toCalculatedInternal };
